
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFilter'
})
export class PhoneFilterPipe implements PipeTransform {
  transform(value: string): string {
    // Check if the value is not empty and has 10 digits
    if (value && /^\d{10}$/.test(value)) {
      return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
    return value; // Return the original value if it doesn't match the format
  }
}
